import axios from "axios";
import { AUTH_TOKEN_KEY, BASE_URL } from "./constants";
import { getFromStorage } from "../utils/storageController";

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
  },
});



const attachApiToken = async (api) => {
  try {
    const apiToken = await getFromStorage(AUTH_TOKEN_KEY);
    if (apiToken) {
      api.defaults.headers.common["Authorization"] = `Bearer ${apiToken}`;
      // api.defaults.headers["x-access-token"] = apiToken;
    }
    return api;
  } catch (error) {
    console.log("REQUEST NOT SECURED");
  }
};


export { api, attachApiToken };
